import _ from 'lodash';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import { COLOR } from 'config/constants';
import { images } from 'assets/images';

const useStyles = makeStyles({
  root: {
    flexDirection: 'column',
    backgroundImage: `url(${images.maskGroup1})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom',
    backgroundSize: '50% auto',
    padding: '50px 0 50px 0',
    color: '#FFF',
  },
  dataContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 600,
    borderRadius: 8,
    padding: 20,
    color: COLOR.BLACK,
  },
  icon: {
    width: 50,
    height: 'auto',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginTop: 20,
    '@media (max-width: 767px)': {
      fontSize: '1.2rem',
    },
  },
  subtitle: {
    fontSize: 15,
    marginTop: 20,
    '@media (max-width: 767px)': {
      fontSize: 12,
    },
  },
});

interface Props {
  className: string;
}

function RequestFeedback({ className }: Props) {
  const styles = useStyles();
  const intl = useIntl();
  const fmtThankYou = intl.formatMessage({ id: 'serviceRequest.thanks' });
  const fmtThanksForFeedback = intl.formatMessage({ id: 'serviceRequest.confirmation' });
  return (
    <Box className={styles.dataContainer}>
      <img src={images.email_sent} alt='email_sent' className={styles.icon} />
      <Typography className={styles.title}>{fmtThankYou}</Typography>
      <Typography className={styles.subtitle}>{fmtThanksForFeedback}</Typography>
    </Box>
  );
}

RequestFeedback.defaultProps = {
  className: null,
};

RequestFeedback.propTypes = {
  className: PropTypes.string,
};

export default RequestFeedback;
